import { FC, useEffect, useState } from 'react'
import { Checkbox, Flex, Text, Switch } from '@chakra-ui/react'
import { Choice } from '../../state/interfaces'

interface DefaultCheckboxProps {
  choice: Choice
  isChecked?: boolean
  onChange?: (value: string, checked: boolean) => void
  style?: Record<string, any>
  type?: 'data' | 'calling'
  toggle?: boolean
}

export const DefaultCheckbox: FC<DefaultCheckboxProps> = ({
  choice: { label, value },
  isChecked,
  type,
  toggle,
  ...props
}) => {
  const [checked, setChecked] = useState<boolean>(false)

  useEffect(() => {
    if (isChecked) setChecked(isChecked)
  }, [isChecked])

  const toggleChecked = () => {
    setChecked(!checked)
  }

  const handleChange = () => {
    toggleChecked()
    props.onChange && props.onChange(value, !checked)
  }

  const handleLabelClick = () => {
    handleChange()
  }

  return (
    <>
      {type === 'data' ? (
        <Flex alignItems="flex-start" minW={{ base: 120, md: 150 }}>
          {toggle && (
            <>
              <Text
                mx={4}
                whiteSpace="normal"
                onClick={handleLabelClick}
                cursor="pointer"
                fontSize={{ base: '14', md: '16' }}
              >
                {label}
              </Text>
              <Flex
                alignItems="center"
                zIndex={2}
                // border="1px solid"
                // borderColor={checked ? 'green.400' : 'gray.300'}
                borderRadius="999px"
              >
                <Switch
                  isChecked={checked}
                  onChange={handleChange}
                  value={value}
                  colorScheme="green"
                  sx={{
                    '.chakra-switch__track': {
                      width: '50px',
                      height: '30px',
                      bg: checked ? 'brand' : 'white',
                      borderRadius: '999px',
                      border: '1px solid',
                      borderColor: checked ? 'brand' : 'gray',
                      boxSizing: 'border-box',
                    },
                    '.chakra-switch__thumb': {
                      width: '23px',
                      height: '23px',
                      bg: checked ? 'white' : 'gray',
                      transform: checked ? 'translateX(21px)' : 'translateX(2px)',
                      transition: 'transform 0.18s, background-color 0.18s',
                      boxShadow: 'none',
                    },
                  }}
                />
              </Flex>
            </>
          )}
        </Flex>
      ) : (
        <Flex alignItems="flex-start" minW={{ base: 120, md: 200 }}>
          <Flex border="1px solid lightgrey" alignItems="center" mt={1} minW={'18px'} zIndex={2}>
            <Checkbox isChecked={checked} onChange={handleChange} value={value} colorScheme="green" zIndex={-1} />
          </Flex>
          <Text
            ml={4}
            whiteSpace="normal"
            onClick={handleLabelClick}
            cursor="pointer"
            fontSize={{ base: '14', md: '16' }}
          >
            {label}
          </Text>
        </Flex>
      )}
    </>
  )
}
